import Tabs from './Tabs';
import TabPane from './TabPane';
import TabContent from './TabContent';

export default Tabs;
export { TabPane, TabContent };



// WEBPACK FOOTER //
// ./ext/tabs/src/index.js